import { IDropdownItem, IDropdownListSearch } from "../../../types/dropdownInterface";
import { DepartmentDropdown, DepartmentDropdownActionType } from "../../actionTypes/master/departmentDropdownActionTypes";

export const getDepartmentListDropdown = (payload: IDropdownListSearch): DepartmentDropdownActionType => ({
  type: DepartmentDropdown.GET_DEPARTMENT_DROPDOWN_LIST,
  payload,
});

export const setDepartmentListDropdown = (payload: Array<IDropdownItem>): DepartmentDropdownActionType => ({
  type: DepartmentDropdown.SET_DEPARTMENT_DROPDOWN_LIST,
  payload,
});
